import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

/** Task 7.1 — the ORGANIZATION's Platform Analytics subscription status. */
export function usePremiumReportSubscription({
  enabled = true,
  organizationId,
}: {
  enabled?: boolean;
  organizationId: string;
}) {
  const { queryFn, queryKey } =
    queryKeys.premium.fetchReportSubscription(organizationId);
  return useQuery({
    enabled: enabled && !!organizationId,
    queryFn,
    queryKey,
  });
}
